import { helper } from '@ember/component/helper';

/**
 * Formatta un numero in stringa con supporto per mezzi (1/2)
 */
function formatNumber2string([number]) {
  if (number == null || isNaN(number)) return '';
  const num = Number(number);
  const sign = num < 0 ? '-' : '';
  const absNum = Math.abs(num);

  // Se il numero ha una parte decimale — su absNum, poi si riapplica il segno
  // (altrimenti -1.5 → -1 e -0.5 → 0 perché num % 1 è negativo).
  if (absNum % 1 !== 0) {
    const decimal = absNum % 1;
    const integer = Math.floor(absNum);

    // Se la parte decimale è vicina a 0.5
    if (decimal > 0.25 && decimal <= 0.75) {
      return integer > 0 ? `${sign}${integer} ½` : `${sign}½`;
    }
  }
  return String(Math.round(num));
}
var formatNumber2string$1 = helper(formatNumber2string);

export { formatNumber2string$1 as default, formatNumber2string };
//# sourceMappingURL=format-number2string.js.map
